import { adoptTokenFromLocation } from '@modules/externalAuth'
import { I18nUtils } from '@modules/I18nUtils.js'
import './assets/css/predefined.css'
import '@static/consts/index'
import '@new-crm/events-editor/dist/events-editor.iife.js'

import { FALLBACK_LOCALE, messages } from '@/locales'

// MEXC-49574. Токен из `?token=` (SSO-переход из виджета колл-центра) должен лежать в
// localStorage раньше, чем уйдёт первый запрос к scrm. `App.vue` шлёт его синхронно в
// `setup`, то есть внутри `app.mount()`, а навигационные guard'ы работают только в
// микротасках — снимать токен там поздно всегда. Отсюда и до `import( './app' )` не
// должно появляться ничего, что ходит в сеть.
adoptTokenFromLocation()

const defaultDatetimeFormat = {
  short: {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
  },

  long: {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  },
}

const i18n = I18nUtils.setupI18n( {
  locale: FALLBACK_LOCALE,
  fallbackLocale: FALLBACK_LOCALE,
  messages,
  datetimeFormats: {
    'en': defaultDatetimeFormat,
    'ru': defaultDatetimeFormat,
    'es': defaultDatetimeFormat,
  },
} as any )
import( './app' )

export {
  i18n,
}
